import { render, staticRenderFns } from "./CompanySettingsEditForm.vue?vue&type=template&id=f58d5342&"
import script from "./CompanySettingsEditForm.vue?vue&type=script&lang=js&"
export * from "./CompanySettingsEditForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanySettingsEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports